document.addEventListener("DOMContentLoaded", function () {

  const logoCarousel = document.querySelector(".logoCarousel");

  if (logoCarousel) {
    const logoCarouselGlide = document.querySelector(".logoCarousel__glide");
    let totalSlides = document.querySelectorAll(".logoCarousel__slide").length;

    if (logoCarouselGlide) {

      let lcGlide = null;

      function initOrDestroyGlide() {
        console.log("init or no glide");
        const windowWidth = window.innerWidth;
        console.log("Window width:", windowWidth);

        if (windowWidth <= 1024) {
          if (!lcGlide) {
            lcGlide = new Glide(logoCarouselGlide, {
              type: 'carousel',
              autoplay: 1500,
              perView: 6,
              startAt: 0,
              focusAt: 0,
              keyboard: false,
              hoverpause: true,
              bound: true,
              gap: 30,
              breakpoints: {
                576: {
                  perView: 3
                },
                768: {
                  perView: 4
                },
                1024: {
                  perView: 6
                }
              }
            });
            lcGlide.mount();
          }
        } else {
          if (lcGlide) {
            lcGlide.destroy();
            lcGlide = null;
            logoCarouselGlide.classList.add('glide--static');
          } else {
            logoCarouselGlide.classList.add('glide--static');
          }
        }
      }

      // Initialize on load
      initOrDestroyGlide();

      // Re-check on resize
      window.addEventListener('resize', initOrDestroyGlide);

    }
  }
});
